// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"48c91f5d","236":"f64f8830","421":"cd4bef36","470":"d0ebced1","563":"b69979ae","666":"ed9497ae","702":"304e5e1d","814":"8df4a763","879":"5783c938"}[chunkId] + ".chunk.js";
};